import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import type { ListCountriesQuery } from '../../../../../../../../../graphql/fragment/audiences/ListCountries.generated';
import type { ListRegionsQuery } from '../../../../../../../../../graphql/fragment/audiences/ListRegions.generated';
import { labelStyles, labelValuePairStyles } from './styles';
import { useMarketDisplayLabels } from './useMarketDisplayLabels';

export type MarketMetadataProps = {
  regionCodes: string[];
  countryCodes: string[];
  regions: ListRegionsQuery['region'];
  countries: ListCountriesQuery['country'];
  dataTest: string;
};

export const MarketMetadata = ({ regionCodes, countryCodes, regions, countries, dataTest }: MarketMetadataProps) => {
  const { t } = useTranslation();
  const { regionLabel, countryLabel } = useMarketDisplayLabels({
    regionCodes,
    countryCodes,
    regions,
    countries,
  });

  return (
    <Box sx={{ ml: 4, mt: 0.5, display: 'flex', flexWrap: 'wrap', rowGap: 0 }} data-test={dataTest}>
      {regionCodes.length > 0 && (
        <Box sx={labelValuePairStyles}>
          <Typography variant="body2" sx={labelStyles}>
            {t('Region:')}
          </Typography>

          <Typography variant="body2">{regionLabel || t('N / A')}</Typography>
        </Box>
      )}

      {countryCodes.length > 0 && (
        <Box sx={labelValuePairStyles}>
          <Typography variant="body2" sx={labelStyles}>
            {t('Country:')}
          </Typography>

          <Typography variant="body2">{countryLabel || t('N / A')}</Typography>
        </Box>
      )}
    </Box>
  );
};
